document.addEventListener("DOMContentLoaded", function () {
    //hide the play info until people hover
    const videos = document.querySelectorAll(".video-wrapper video");

    videos.forEach(video => {
        const overlay = video.nextElementSibling;
        // Show controls on mouse enter
        video.addEventListener("mouseenter", () => {
            video.setAttribute("controls", "controls");
        });

        // Hide controls on mouse leave
        video.addEventListener("mouseleave", () => {
            video.removeAttribute("controls");
        });

        // Hide overlay when video plays
        video.addEventListener("play", () => {
            overlay.style.opacity = 0;
        });

        // Show overlay when video pauses
        video.addEventListener("pause", () => {
            overlay.style.opacity = 1;
        });
    });
    //
    const sliderWrapper = document.querySelector(".video-slider-wrapper");
    const prevBtn = document.getElementById("custom_prevBtn");
    const nextBtn = document.getElementById("custom_nextBtn");

    if (!sliderWrapper || !prevBtn || !nextBtn) return; // Prevent errors if elements are missing

    const videoSlides = document.querySelectorAll(".video-slide");
    const videoWidth = videoSlides[0]?.offsetWidth || 0; // Get video width dynamically
    const gap = 25; // Gap size between videos

    function updateButtonStates() {
        const scrollLeft = sliderWrapper.scrollLeft;
        const maxScrollLeft = sliderWrapper.scrollWidth - sliderWrapper.clientWidth;

        if (scrollLeft <= 0) {
            prevBtn.classList.add("disabled");
        } else {
            prevBtn.classList.remove("disabled");
        }

        if (scrollLeft >= maxScrollLeft) {
            nextBtn.classList.add("disabled");
        } else {
            nextBtn.classList.remove("disabled");
        }
    }

    function scrollNext() {
        sliderWrapper.scrollBy({ left: videoWidth + gap, behavior: "smooth" });
    }

    function scrollPrev() {
        sliderWrapper.scrollBy({ left: -(videoWidth + gap), behavior: "smooth" });
    }

    nextBtn.addEventListener("click", scrollNext);
    prevBtn.addEventListener("click", scrollPrev);
    sliderWrapper.addEventListener("scroll", updateButtonStates);

    // Scroll to the third video (index 2) and center it
    const thirdVideoIndex = 2;
    const scrollPosition = thirdVideoIndex * (videoWidth + gap) - (sliderWrapper.clientWidth - videoWidth) / 2;

    // Ensure the scroll position is within valid bounds
    const maxScrollLeft = sliderWrapper.scrollWidth - sliderWrapper.clientWidth;
    sliderWrapper.scrollLeft = Math.max(0, Math.min(scrollPosition, maxScrollLeft));

});
